const content = (
  <div>
    <p>
      Le Parcours de Femmes est un dispositif unique imaginé et animé par
      Nathalie Levy (NATELCO), coach professionnelle, formatrice et consultante.
      Il s’adresse aux femmes entrepreneures, collaboratrices, salariées ou
      indépendantes souhaitant développer leur potentiel personnel et
      professionnel, anticiper les transitions et relever les défis avec
      confiance. Ce programme est proposé sous plusieurs formats : parcours
      complet, parcours court, parcours mentorat thématique et séances
      individuelles ou collectives.
    </p>
    <h2>Public concerné</h2>
    <p>À l’issue de la formation, le participant sera en mesure de :</p>
    <ul>
      <li>
        Femmes entrepreneures, collaboratrices, salariées ou indépendantes
      </li>
      <li>Aucune restriction de secteur ou de fonction</li>
    </ul>
    <h2>Prérequis</h2>
    <p>
      Aucun prérequis, sauf motivation à s’impliquer dans un parcours de
      développement et à participer activement aux ateliers.
    </p>
    <h2>Objectifs pédagogiques</h2>
    <p>À l’issue du parcours, la participante sera en mesure de :</p>
    <ul>
      <li>Développer une meilleure connaissance de soi et de ses ressources</li>
      <li>
        Prendre du recul pour piloter ses choix de carrière ou de projet
        entrepreneurial
      </li>
      <li>
        Anticiper et gérer les transitions (changements de poste, reconversion,
        évolution de rôle)
      </li>
      <li>Développer des compétences de résilience et de transformation</li>
      <li>
        Renforcer sa posture de leader dans un contexte féminin spécifique (ex :
        ménopause et leadership)
      </li>
      <li>Élaborer un plan d’actions concret et aligné</li>
    </ul>
    <h2>Organisation</h2>
    <h3>Formules possibles :</h3>
    <ul>
      <li>
        <b>Parcours complet global</b> : 1 atelier par mois pendant 9 mois (1
        séance de 3h en présentiel ou distanciel)
      </li>
      <li>
        <b>Parcours court</b> : 1 atelier par mois pendant 5 mois (1 séance de
        2h30)
      </li>
      <li>
        <b>Parcours Mentorat thématique</b> : 3 à 5 séances individuelles ou
        collectives de 2h sur une thématique au choix
        <ul>
          <li>
            Exemples : Anticiper et gérer les transitions / Transformation et
            Résilience / Approche stratégique du changement / Ménopause et
            Leadership / Oser, entreprendre et s’aligner
          </li>
        </ul>
      </li>
      <li>
        <b>Coachings individuels ou en petits groupes</b>
      </li>
    </ul>
    <h3>Méthodes pédagogiques</h3>
    <ul>
      <li>Apports théoriques interactifs</li>
      <li>Supports visuels, fiches pratiques, extraits de films</li>
      <li>Discussions de groupe et partages d’expériences</li>
      <li>Exercices pratiques et études de cas</li>
      <li>Ateliers en binômes ou sous-groupes</li>
      <li>Élaboration de plans d’action personnalisés</li>
    </ul>
    <h2>Modalités pratiques</h2>
    <ul>
      <li>
        <b>Présentiel, distanciel ou mixte</b> (webinaire + séances
        présentielles)
      </li>
      <li>
        <b>Taille des groupes </b>: individuel ou groupe restreint (jusqu’à 10
        participantes)
      </li>
      <li>
        <b>Financement </b>: prise en charge possible par l’entreprise ou
        financement individuel
      </li>
      <li>
        <b>Planning </b>: inscriptions ouvertes toute l’année pour l’individuel
        ; planning des sessions collectives établi chaque semestre
      </li>
    </ul>
    <h2>Accessibilité & inclusion handicap</h2>
    <p>
      Nos parcours sont accessibles à toutes. Pour toute situation de handicap,
      merci de nous contacter pour étudier ensemble les aménagements possibles
      avec notre <b>référent handicap</b>.
    </p>
    <h2>Modalités d’évaluation</h2>
    <ul>
      <li>Auto-diagnostic initial et test de positionnement</li>
      <li>
        Évaluations formatives tout au long du parcours (exercices, mises en
        pratique)
      </li>
      <li>Quiz ou livrable final pour valider les acquis</li>
      <li>Questionnaire de satisfaction à chaud et à froid</li>
      <li>
        Attestation de réalisation et de compétences remises en fin de parcours
      </li>
    </ul>
    <h2>Tarif indicatif</h2>
    <p>
      Variable selon le format choisi (intra / inter, individuel / collectif).
      Nous consulter pour un devis personnalisé.
    </p>
  </div>
);

export default content;
